import builder from '../builder';
import PictureLandscape from '../../streamline-icons/light/picture-landscape.svg';

export default builder('IconPictureLandscapeLight', PictureLandscape);
